import { AxiosError } from 'axios';
import { GET_ANNOUNCEMENT_FEATURE_URL } from '../../constants/apiUrls';
import { GET_ANNOUNCEMENT_FEATURE_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface DropdownOption {
  code: string;
  description: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: DropdownOption[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAnnouncementFeature = ({ onSuccess, onError }: Input = {}) => {
  const getAnnouncementFeature = async () => {
    const res = await axiosClient.get<DropdownOption[]>(GET_ANNOUNCEMENT_FEATURE_URL);
    return res.data;
  };

  return useCustomQuery(GET_ANNOUNCEMENT_FEATURE_QUERY_KEY, getAnnouncementFeature, {
    onSuccess,
    onError,
  });
};
